export const imageUrl = `https://sisuper.kabngawi.id`;